export default __webpack_public_path__ + "static/icon-15-4-20c81412f710362405cc43c0e40d4662.png";